import FanRequireSubscribeModalComponent from "./FanRequireSubscribeModalComponent";

export default FanRequireSubscribeModalComponent;
